// useSrpAuth.js
import { useApiService } from "./useApiService"
import srp, { generateEphemeral } from "secure-remote-password/client"
import { useCallback } from "react"

export function useSrpAuth() {
  const { postData } = useApiService()

  const registerSrp = useCallback(async (username, password) => {
    const salt = srp.generateSalt()
    const privateKey = await srp.derivePrivateKey(salt, username, password)
    const verifier = await srp.deriveVerifier(privateKey)

    const data = await postData("users/register", {
      username,
      salt: salt,
      verifier: verifier,
    })

    return data.message // return message so doSignup can use it
  }, [])

  const loginSrp = useCallback(async (username, password, setLoading) => {
    if (!username) return false
    // Step 1: start login, get salt and server ephemeral (B) from server

    const response = await postData("users/srp/start", { username })
    let salt, BHex

    if (response?.salt) {
      salt = response.salt
      BHex = response.B
    } else {
      return "You Need To Reset Paswword. click on forgot password"
    }

    // saltHex and BHex are hex strings, pass as is (no .toString("hex")!)
    const serverPublicEphemeral = BHex

    // Step 2: generate client ephemeral (a, A)
    const clientEphemeral = generateEphemeral() // returns { secret, public }

    // Step 3: compute private key from salt, username, and password
    const privateKey = await srp.derivePrivateKey(salt, username, password)

    // Step 4: derive client session with all hex strings
    const clientSession = srp.deriveSession(
      clientEphemeral?.secret, // hex string
      serverPublicEphemeral, // already hex string
      salt, // already hex string
      username, // string
      privateKey // hex string from derivePrivateKey
    )
    // Step 5: send A and M1 to server finish endpoint
    const finishResponse = await postData("users/srp/finish", {
      username,
      A: clientEphemeral?.public, // convert Buffer to hex string
      M1: clientSession?.proof, // convert Buffer to hex string
    })

    setLoading(false)
    if (clientEphemeral && clientSession && finishResponse?.M2) {
      try {
        const verified = srp.verifySession(
          clientEphemeral?.public, // A, the client ephemeral public (hex)
          clientSession, // { key, proof }
          finishResponse?.M2 // serverSession.proof (M2, hex)
        )

        if (verified !== false) {
          await postData("users/srp/getverified", {
            M1: clientSession.proof,
            username,
            // M2: finishResponse?.M2,
            // A: clientEphemeral?.public,
          })
        }
        return verified !== false
      } catch (err) {
        return false
      }
    }
  }, [])

  return { registerSrp, loginSrp }
}
